/**
 * It is Barrel: see https://stackoverflow.com/a/37564980/2000468
 */
export * from './theme-picker.component';



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/shared/theme-picker/index.ts